export default __webpack_public_path__ + "static/media/Group 3406.8724e280.png";